import { Spinner, Gradient, Thumbnail, RedirectingSpinner } from './Loaders';

const Loader = () => null;

Loader.Thumbnail = Thumbnail;
Loader.Spinner = Spinner;
Loader.Gradient = Gradient;
Loader.RedirectingSpinner = RedirectingSpinner;

export { Loader };
